import React from 'react';
import { Card, CardHeader } from '../components/Card';
import { ROUTES } from '../config/routes';
import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

const Home: React.FC = () => {
  const { user } = useAuth();

  // Redirect admin users to admin home page
  if (user?.isAdminAccount) {
    return <Navigate to={ROUTES.ADMIN_HOME()} replace />;
  }

  return (
    <>
      <div className="mb-8 lg:mb-20">
        <h2 className="text-black/60">Welcome back</h2>
        {/* TODO:Status */}
      </div>
      <div className="grid-dashboard grid lg:grid-cols-4 gap-4 auto-rows-[125px] lg:grid-rows-[repeat(2,_minmax(172px,_1fr))] ">
        <Card to={ROUTES.PROMOTIONS()} variant="secondary">
          <CardHeader title="Businesses & Promotions" description="Manage your businesses and promotions" />
        </Card>
        <Card to={ROUTES.TRANSACTIONS()} variant="tertiary">
          <CardHeader title="Transactions" description="All transactions" />
        </Card>
        <Card to={ROUTES.INSIGHTS()}>
          <CardHeader
            title="Insights"
            description="Consumer demographics and data"
          />
        </Card>
        <Card to={ROUTES.BILLING()} variant="quinary">
          <CardHeader
            title="Billing & Invoices"
            description="View billing and invoices"
          />
        </Card>
        <Card to={ROUTES.UPGRADE_MARKETING_PACKAGE()} variant="quaternary" className="lg:col-span-2 relative overflow-hidden animate-pulse-scale hover:ring-2 hover:ring-[#c47a10]">
          <div className="absolute top-3 right-3 bg-primary text-white text-xs font-semibold px-2 py-1 rounded-full flex items-center gap-1">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
            </span>
            NEW
          </div>
          <CardHeader
            title="Upgrade Marketing Package"
            description="Purchase a booster to promote your business"
          />
        </Card>
      </div>
    </>
  );
};

export default Home;
